import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "@onefront/react-sdk";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";
import TextField from "@vapor/react-material/TextField";

interface SearchButtonProps {
  searchValue?: string;
  setSearchValue: (value: string) => void;
  width?: string;
  onSearch?: () => void;
}

const SearchInput: React.FC<SearchButtonProps> = ({
  searchValue,
  setSearchValue,
  width = "200px",
  onSearch,
}) => {
  const { t } = useTranslation("DOCS");
  return (
    <Stack direction="row" alignItems="end">
      <TextField
        placeholder={t("document.search.default")}
        value={searchValue}
        variant="outlined"
        sx={{
          width: width,
        }}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
      />
      <Button
        onClick={(e) => {
          if (onSearch) onSearch();
        }}
        size="medium"
        sx={{
          "&.MuiButtonBase-root.MuiButton-root.MuiButton-sizeMedium": {
            borderRadius: 0,
            minWidth: 40,
            p: 1,
          },
        }}
        variant="contained"
      >
        <SearchIcon />
      </Button>
    </Stack>
  );
};

export default SearchInput;
